import { useSelector } from "react-redux";
import styled from "styled-components";

import Banner from "./Banner";
import SectionSelector from "./SectionSelector";
import {
  LAPTOP,
  WIDESCREEN
} from "../../../../constants/widget";
import FeedbackSection from "./Feedback";
import { INTERACTED_WITH_AI } from "../../../../constants/chat";
import { FEEDBACK_SUBMIT } from "../../../../constants/events";

const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  ${({ isExpanded, windowDimensions }) => {
    if (!isExpanded) {
      return "";
    }
    let template = "";
    if (windowDimensions?.width <= LAPTOP) {
      template = "180px auto 360px";
    } else if (windowDimensions?.width <= WIDESCREEN) {
      template = "180px auto 360px";
    } else {
      template = "400px auto 400px";
    }
    return `
      display: grid;
      grid-template-columns: ${template};
    `;
  }}
  box-shadow: 0 -4px 0.25rem -4px rgba(0,0,0,0.25);
`;

const NoSectionContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  ${({ isExpanded, windowDimensions, showFeedbackIcon }) => {
    let template = "";
    if (!showFeedbackIcon) {
        template = "auto"
    }
    else if (!isExpanded) {
      template = "auto auto"
    }
    else {
      if (windowDimensions?.width <= LAPTOP) {
        template = "180px auto 360px";
      } else if (windowDimensions?.width <= WIDESCREEN) {
        template = "180px auto 360px";
      } else {
        template = "400px auto 400px";
      }
    }
    return `
      display: grid;
      grid-template-columns: ${template};
    `;
  }}
  box-shadow: 0 -4px 0.25rem -4px rgba(0,0,0,0.25);
`;

const SectionContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const EmptyDiv = styled.div`
  use-select: none;
`;

function Footer({ showSectionSelector, isExpanded }) {
  const windowDimensions = useSelector((state) => state?.content?.windowDimensions);
  const feedbackFormEnabled = useSelector((state) => state?.org?.customizations?.feedbackFormConfig?.enableFeedbackForms);
  const chatStage = useSelector((state) => state?.chat?.chatStage);
  const showFeedbackForm = useSelector((state) => state?.form?.showFeedbackForm);
  const interactedWithChat = chatStage >= INTERACTED_WITH_AI;
  const showFeedbackIcon = feedbackFormEnabled && interactedWithChat && showFeedbackForm !== FEEDBACK_SUBMIT;
  return showSectionSelector
    ? (
      <>
        {!isExpanded && (
          <SectionContainer>
            <Banner />
            {showFeedbackIcon && <FeedbackSection />}
          </SectionContainer>
        )}
        <Container isExpanded={isExpanded} windowDimensions={windowDimensions}>
          {isExpanded && (
            <>
              {!(showFeedbackIcon) && <EmptyDiv />}
              <Banner />
              {showFeedbackIcon && <FeedbackSection />}
            </>
          )}
          <SectionSelector isExpanded={isExpanded} windowDimensions={windowDimensions} />
        </Container>
      </>
    ) : (
      <>
        <NoSectionContainer isExpanded={isExpanded} windowDimensions={windowDimensions} showFeedbackIcon={showFeedbackIcon}>
          {!showFeedbackIcon && <EmptyDiv />}
          <Banner />
          {showFeedbackIcon && <FeedbackSection />}
        </NoSectionContainer>
      </>
    );
}

export default Footer;
